import './App.css';
import React, {Component} from 'react';
import {JavascriptViewer} from "@3dweb/360javascriptviewer";

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageId: 'monroe-snow-sofa'
        };

        this.initJsv('monroe-snow-sofa', 'jsv-holder-1')
        this.initJsv('cailin-sofa', 'jsv-holder-2')
        this.initJsv('kendall-sofa', 'jsv-holder-3')

    }

    initJsv = (imageId, holderId) => {
        let jsv = new JavascriptViewer({
            mainHolderId: `${holderId}`,
            mainImageId: `${imageId}`,
            imageUrlFormat: `${imageId}-0xx.png`,
            totalFrames: 8,
            defaultProgressBar: true,
            speed: 300,
            inertia: 12,
            reverse: true,
            zoom: false,
            autoRotate: 1,
            stopAtEdges: true,
            // startFrameNo: 0,
            notificationConfig: {
                dragToRotate: {
                    showStartToRotateDefaultNotification: true,
                    mainColor: "rgba(0,0,0,0.20)",
                    textColor: "rgba(243,237,237,0.80)",
                }
            }
        });
        jsv.start()
            .then(() => console.log('viewer started'))
            .catch((e) => console.log('failed loading 360 viewer: ' + e))
    }

    loadImage = (imageId) => {
        this.setState({imageId: imageId})
    }

    render() {
        let unselectedImageStyle = {width: '100%', margin: '10px 0'};
        let selectedImageStyle = {
            ...unselectedImageStyle,
            border: '2px solid #4285f4',
            borderRadius: '10px',
        };

        return (
            <div className="App"
                 style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{maxHeight: '100%'}}>
                    <div style={{
                        margin: '0 5vw',
                        display: "flex",
                        overflowX: 'auto',
                        overflowY: 'auto',
                        flexDirection: 'column'
                    }}>
                        <img onClick={() => this.loadImage('monroe-snow-sofa')}
                             alt={"Snow Sofa"}
                             style={this.state.imageId === 'monroe-snow-sofa' ? selectedImageStyle : unselectedImageStyle}
                             src={'https://homely-renders.s3.us-east-1.amazonaws.com/base-images/monroe-snow-sofa-005.png'}/>
                        <img onClick={() => this.loadImage('cailin-sofa')}
                             alt={"Cailin Sofa"}
                             style={this.state.imageId === 'cailin-sofa' ? selectedImageStyle : unselectedImageStyle}
                             src={'https://homely-renders.s3.us-east-1.amazonaws.com/base-images/cailin-sofa-005.png'}/>
                        <img onClick={() => this.loadImage('kendall-sofa')}
                             alt={"Kendall Sofa"}
                             style={this.state.imageId === 'kendall-sofa' ? selectedImageStyle : unselectedImageStyle}
                             src={'https://homely-renders.s3.us-east-1.amazonaws.com/base-images/kendall-sofa-005.png'}/>
                    </div>
                </div>

                <div>
                    <div id="jsv-holder-1" className={"jsv-holder"}
                         style={this.state.imageId === 'monroe-snow-sofa' ? {} : {display: "none"}}>
                        <img id="monroe-snow-sofa" alt="Sofa 3D Model"
                             src={`https://homely-renders.s3.us-east-1.amazonaws.com/base-images/monroe-snow-sofa-001.png`}/>
                    </div>
                    <div id="jsv-holder-2" className={"jsv-holder"}
                         style={this.state.imageId === 'cailin-sofa' ? {} : {display: "none"}}>
                        <img id="cailin-sofa" alt="Sofa 3D Model"
                             src={`https://homely-renders.s3.us-east-1.amazonaws.com/base-images/cailin-sofa-001.png`}/>
                    </div>
                    <div id="jsv-holder-3" className={"jsv-holder"}
                         style={this.state.imageId === 'kendall-sofa' ? {} : {display: "none"}}>
                        <img id="kendall-sofa" alt="Sofa 3D Model"
                             src={`https://homely-renders.s3.us-east-1.amazonaws.com/base-images/kendall-sofa-001.png`}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
